import React from 'react';
import styles from './CheckComponent.module.scss';
import { ReactComponent as CheckIcon } from "./ic_check_component.svg";
import classNames from "classnames";

const CheckComponent = ({ isSelected, className, style, isParentHovered, isDisabled, isHoverable }) => {
    return <CheckIcon className={classNames(styles.base, className, {
        [styles['hovered']]: isParentHovered,
        [styles['selected']]: isSelected,
        [styles['disabled']]: isDisabled,
        [styles['hoverable']]: isHoverable
    })} style={style}/>
}

export default CheckComponent;